import React from 'react'
import PropTypes from 'prop-types'
import Svg from 'src/Components/shared/Svg'
import { uniqueId } from 'lodash'

const genId = () => uniqueId('purchasePowerTeaser')
const a = genId()
const b = genId()
const c = genId()
const d = genId()
const e = genId()
const f = genId()
const g = genId()
const h = genId()
const i = genId()
const j = genId()
const k = genId()
const l = genId()
const m = genId()
const n = genId()
const o = genId()
const p = genId()
const q = genId()
const r = genId()
const s = genId()

const propTypes = {
  className: PropTypes.string
}

const PurchasePowerTeaserScreen = ({ className, ...restProps }) => (
  <Svg viewBox='0 0 550 405' className={className} {...restProps}>
    <defs>
      <path id={b} d='M0 0h450v369H0z' />
      <filter
        id={a}
        width='112.4%'
        height='115.2%'
        x='-6.2%'
        y='-7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='9'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0'
        />
      </filter>
      <path id={d} d='M0 0h241v75H0z' />
      <filter
        id={c}
        width='113.3%'
        height='142.7%'
        x='-6.6%'
        y='-18.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='5'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path
        id={e}
        d='M53.426 28.18l-9.557-16.102c-.774-1.303-2.202-2.104-3.75-2.102l-19.145.02c-1.548 0-2.979.804-3.756 2.109L7.629 28.226a4.11 4.11 0 0 0-.004 4.213l9.556 16.102c.774 1.304 2.203 2.105 3.751 2.103l19.145-.02c1.548-.001 2.979-.805 3.755-2.11l9.59-16.122a4.11 4.11 0 0 0 .004-4.212z'
      />
      <filter
        id='f'
        width='114.9%'
        height='117.2%'
        x='-7.5%'
        y='-6.1%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='1'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path id={h} d='M0 0h241v75H0z' />
      <filter
        id={g}
        width='113.3%'
        height='142.7%'
        x='-6.6%'
        y='-18.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='5'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path
        id={i}
        d='M51.444 35.116L42.27 19.658c-.743-1.25-2.113-2.02-3.597-2.02H20.327c-1.484 0-2.854.77-3.597 2.02L7.556 35.116a3.947 3.947 0 0 0 0 4.042l9.174 15.459c.743 1.25 2.113 2.02 3.597 2.02h18.346c1.484 0 2.854-.77 3.597-2.02l9.174-15.46a3.947 3.947 0 0 0 0-4.04z'
      />
      <filter
        id={j}
        width='115.6%'
        height='117.9%'
        x='-7.8%'
        y='-6.4%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='1'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path id={m} d='M0 0h241v75H0z' />
      <filter
        id={l}
        width='113.3%'
        height='142.7%'
        x='-6.6%'
        y='-18.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='5'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path id={o} d='M0 0h241v75H0z' />
      <filter
        id={n}
        width='113.3%'
        height='142.7%'
        x='-6.6%'
        y='-18.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='5'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path
        id={p}
        d='M51.18 26.116l-9.175-15.458c-.742-1.25-2.113-2.02-3.596-2.02H20.062c-1.483 0-2.853.77-3.597 2.02L7.292 26.116a3.947 3.947 0 0 0 0 4.042l9.173 15.459c.744 1.25 2.114 2.02 3.597 2.02H38.41c1.483 0 2.854-.77 3.596-2.02l9.174-15.46a3.947 3.947 0 0 0 0-4.04z'
      />
      <filter
        id={q}
        width='115.6%'
        height='117.9%'
        x='-7.8%'
        y='-6.4%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='1'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
      <path
        id={r}
        d='M51.18 26.116l-9.175-15.458c-.742-1.25-2.113-2.02-3.596-2.02H20.062c-1.483 0-2.853.77-3.597 2.02L7.292 26.116a3.947 3.947 0 0 0 0 4.042l9.173 15.459c.744 1.25 2.114 2.02 3.597 2.02H38.41c1.483 0 2.854-.77 3.596-2.02l9.174-15.46a3.947 3.947 0 0 0 0-4.04z'
      />
      <filter
        id={s}
        width='115.6%'
        height='117.9%'
        x='-7.8%'
        y='-6.4%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='1' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='1'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(47 16)'>
        <use fill='#000' filter={`url(#${a})`} href={`#${b}`} />
        <use fill='#302E35' href={`#${b}`} />
      </g>
      <text
        fill='#F3EFF1'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='24'
        fontWeight='300'
        transform='translate(47 16)'
      >
        <tspan x='37.313' y='73.852'>
          If you bought another home, how{' '}
        </tspan>{' '}
        <tspan x='90.697' y='105.852'>
          much could you afford?
        </tspan>
      </text>
      <g transform='translate(23.291 158)'>
        <use fill='#000' filter={`url(#${c})`} href={`#${d}`} />
        <use fill='#3A383F' href={`#${d}`} />
      </g>
      <text
        fill='#F3EFF1'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='18'
        fontWeight='300'
        transform='translate(23.291 158)'
      >
        <tspan x='32.81' y='32.875'>
          Move to your{' '}
        </tspan>{' '}
        <tspan x='32.81' y='56.875'>
          dream home
        </tspan>
      </text>
      <text
        fill='#3CE967'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='22'
        transform='translate(23 158)'
      >
        <tspan x='166' y='46'>
          $855k
        </tspan>
      </text>
      <g transform='rotate(30 -284.6 100.748)'>
        <use fill='#000' filter={`url(#${f})`} href={`#${e}`} />
        <use fill='#535256' href={`#${e}`} />
      </g>
      <g fill='#BBB2B7'>
        <path d='M31.68 194.792H13.834a.258.258 0 0 0-.26.255v10.002h-1.52a.258.258 0 0 0-.26.256v.69c0 .14.116.255.26.255H33.46c.143 0 .26-.114.26-.256v-.69a.258.258 0 0 0-.26-.255H31.94v-10.002a.258.258 0 0 0-.26-.255zm-14.495 7.055a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.26-.256v-1.703c0-.141.117-.256.26-.256h1.73c.142 0 .259.115.259.256v1.703zm0-3.789a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.26-.256v-1.703c0-.14.117-.255.26-.255h1.73c.142 0 .259.114.259.255v1.703zm3.348 3.789a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.259-.256v-1.703c0-.141.116-.256.26-.256h1.728c.144 0 .26.115.26.256v1.703zm0-3.789a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.259-.256v-1.703c0-.14.116-.255.26-.255h1.728c.144 0 .26.114.26.255v1.703zm3.348 6.161a.258.258 0 0 1-.26.256h-1.728a.258.258 0 0 1-.26-.256v-4.075c0-.141.116-.256.26-.256h1.729c.143 0 .26.115.26.256v4.075zm0-6.16a.258.258 0 0 1-.26.255h-1.728a.258.258 0 0 1-.26-.256v-1.703c0-.14.116-.255.26-.255h1.729c.143 0 .26.114.26.255v1.703zm3.349 3.788a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.26-.256v-1.703c0-.141.117-.256.26-.256h1.73c.142 0 .259.115.259.256v1.703zm0-3.789a.258.258 0 0 1-.26.256h-1.729a.258.258 0 0 1-.26-.256v-1.703c0-.14.117-.255.26-.255h1.73c.142 0 .259.114.259.255v1.703zm3.348 3.789a.258.258 0 0 1-.26.256H28.59a.258.258 0 0 1-.26-.256v-1.703c0-.141.117-.256.26-.256h1.73c.143 0 .259.115.259.256v1.703zm0-3.789a.258.258 0 0 1-.26.256H28.59a.258.258 0 0 1-.26-.256v-1.703c0-.14.117-.255.26-.255h1.73c.143 0 .259.114.259.255v1.703zM10.267 193.375h24.525c.23 0 .351-.277.2-.453l-5.567-6.454a.263.263 0 0 0-.2-.092H19.79a.27.27 0 0 1-.267-.273v-1.83a.27.27 0 0 0-.266-.273h-1.297a.27.27 0 0 0-.266.273v1.83a.27.27 0 0 1-.266.273h-1.594a.264.264 0 0 0-.2.092l-5.566 6.454c-.152.176-.03.453.2.453z' />
      </g>
      <g transform='translate(269 159)'>
        <g transform='translate(29.279)'>
          <use fill='#000' filter={`url(#${g})`} href={`#${h}`} />
          <use fill='#3A383F' href={`#${h}`} />
        </g>
        <text
          fill='#F3EFF1'
          fontFamily='OpenSans-Light, Open Sans'
          fontSize='18'
          fontWeight='300'
          transform='translate(29.279)'
        >
          <tspan x='30.086' y='31'>
            Buy a rental{' '}
          </tspan>{' '}
          <tspan x='30.086' y='55'>
            property
          </tspan>
        </text>
        <text
          fill='#3CE967'
          fontFamily='OpenSans-Regular, Open Sans'
          fontSize='22'
          transform='translate(29)'
        >
          <tspan x='159' y='44'>
            $374k
          </tspan>
        </text>
        <mask id='k' fill='#fff'>
          <use href={`#${i}`} />
        </mask>
        <g transform='rotate(30 29.5 37.137)'>
          <use fill='#000' filter={`url(#${j})`} href={`#${i}`} />
          <use fill='#535256' href={`#${i}`} />
        </g>
        <g fill='#BBB2B7' mask={`url(#${k})`}>
          <path d='M42.464 40.704l-2.85-2.89v-4.332h-1.9v2.407L34.864 33l-7.6 7.704v.481h1.9V46h4.75v-2.889h1.9V46h4.75v-4.815h1.9zM20.966 27.737c.895-.183 1.88-.004 2.81.73.433.342.75.72.97 1.118a1.88 1.88 0 0 0-1.12-.606c-.69-.1-1.377.234-1.79.792a1.68 1.68 0 0 0-.309.665c-.032.15.144.264.266.17.417-.321.971-.491 1.649-.397.557.078.985.305 1.292.617-.049.042-5.206 5.809-5.47 15.174h3.172c-.277-10.33 3.338-14.345 3.34-14.361.347.229.64.578.83 1.067.248.635.206 1.214-.018 1.689-.065.138.086.282.224.218.206-.094.405-.239.587-.452.453-.528.63-1.267.372-1.91a1.848 1.848 0 0 0-.848-.945c.442.121.886.342 1.315.684.918.723 1.32 1.618 1.35 2.508.007.168.213.243.322.115.298-.356.522-.806.603-1.404.141-1.04-.22-2.119-1.052-2.763a2.978 2.978 0 0 0-.871-.466c.03.002.06.004.092.009 1.12.13 1.919.645 2.423 1.344.115.164.383.094.402-.105a2.62 2.62 0 0 0-.19-1.262c-.42-1.054-1.35-1.84-2.487-1.935a2.95 2.95 0 0 0-1.174.138 2.878 2.878 0 0 0-.127-1.164c-.352-1.078-1.334-1.8-2.462-1.97a2.67 2.67 0 0 0-1.31.112c-.181.062-.19.321-.013.392.812.324 1.51.982 1.896 2.05.01.03.021.057.03.087a2.945 2.945 0 0 0-.654-.737c-.823-.659-1.963-.767-2.95-.395-.587.22-.985.553-1.266.937a.163.163 0 0 0 .166.256z' />
        </g>
      </g>
      <g transform='translate(299 258)'>
        <use fill='#000' filter={`url(#${l})`} href={`#${m}`} />
        <use fill='#3A383F' href={`#${m}`} />
      </g>
      <g transform='translate(23 258)'>
        <use fill='#000' filter={`url(#${n})`} href={`#${o}`} />
        <use fill='#3A383F' href={`#${o}`} />
      </g>
      <text
        fill='#F3EFF1'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='18'
        fontWeight='300'
        transform='translate(-6 258)'
      >
        <tspan x='59' y='32'>
          Rent your home{' '}
        </tspan>{' '}
        <tspan x='59' y='56'>
          &amp; buy another
        </tspan>
      </text>
      <text
        fill='#3CE967'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='22'
        transform='translate(-6 258)'
      >
        <tspan x='195' y='45'>
          $385k
        </tspan>
      </text>
      <g transform='rotate(30 -473.86 150.941)'>
        <use fill='#000' filter={`url(#${q})`} href={`#${p}`} />
        <use fill='#535256' href={`#${p}`} />
      </g>
      <text
        fill='#F3EFF1'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='18'
        fontWeight='300'
        transform='translate(-7 16)'
      >
        <tspan x='337' y='274'>
          Sell &amp; pocket{' '}
        </tspan>{' '}
        <tspan x='337' y='298'>
          the cash
        </tspan>
      </text>
      <text
        fill='#3CE967'
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='22'
        transform='translate(-7 16)'
      >
        <tspan x='464' y='287'>
          $350k
        </tspan>
      </text>
      <g>
        <g transform='rotate(30 -335.86 665.964)'>
          <use fill='#000' filter={`url(#${s})`} href={`#${r}`} />
          <use fill='#535256' href={`#${r}`} />
        </g>
      </g>
      <g fill='#BBB2B7'>
        <path d='M35.2 293.704l-2.85-2.89v-4.332h-1.9v2.407L27.6 286l-6.1 6.5 5.15 5.107v-1.496h1.9V299h4.75v-4.815h1.9zM26.2 299.704L18.6 292l-7.6 7.704v.481h1.9V305h4.75v-2.889h1.9V305h4.75v-4.815h1.9z' />
      </g>
      <g fill='#BBB2B7'>
        <path d='M306.724 295.03l-2.215-2.236v-6.114h-2.694v3.397l-4.04-4.077L287 296.87v.681h2.694v6.794h6.734v-4.077h2.694v4.077h3.803s-.077-.198-.153-.458c-.09-.3.038-.598.038-.598s-.768-.455-.904-1.17c-.135-.697.253-1.35.253-1.35s-.422-.777-.26-1.425c.184-.733.827-1.095.827-1.095s-.159-.748.364-1.408c.57-.718 1.272-.644 1.272-.644s.145-.696.788-1.107c.585-.37 1.574-.06 1.574-.06z' />
        <path
          fillRule='nonzero'
          d='M313.076 301.279l-.16-.22a.69.69 0 0 1-.006-.806l.156-.221a.692.692 0 0 0-.238-1.01l-.24-.129a.691.691 0 0 1-.352-.725l.044-.268a.69.69 0 0 0-.65-.806l-.27-.01a.687.687 0 0 1-.63-.5l-.075-.262a.687.687 0 0 0-.932-.443l-.248.107a.685.685 0 0 1-.784-.173l-.18-.202a.684.684 0 0 0-1.032.006l-.178.204a.685.685 0 0 1-.78.185l-.25-.103a.685.685 0 0 0-.925.458l-.07.262a.687.687 0 0 1-.624.507l-.27.015a.69.69 0 0 0-.636.816l.05.265a.695.695 0 0 1-.342.73l-.238.13a.696.696 0 0 0-.222 1.014l.16.22a.69.69 0 0 1 .006.806l-.156.221a.692.692 0 0 0 .238 1.01l.24.129c.26.139.402.433.352.725l-.044.268a.69.69 0 0 0 .65.806l.27.01a.687.687 0 0 1 .63.5l.074.262c.117.4.553.606.933.443l.248-.107a.683.683 0 0 1 .784.175l.18.202a.684.684 0 0 0 1.03-.008l.178-.204a.685.685 0 0 1 .78-.185l.25.103a.685.685 0 0 0 .924-.458l.07-.262a.687.687 0 0 1 .625-.507l.27-.014a.69.69 0 0 0 .636-.816l-.05-.266a.695.695 0 0 1 .342-.73l.238-.13a.696.696 0 0 0 .224-1.014zm-3.767 1.174a1.451 1.451 0 0 1-.738.478c-.128.034-.186.103-.18.236.006.13 0 .264 0 .395 0 .118-.06.18-.176.183a7.37 7.37 0 0 1-.422 0c-.124-.002-.182-.073-.184-.193-.002-.097-.002-.194-.002-.289-.002-.213-.008-.221-.212-.253a2.58 2.58 0 0 1-.752-.218c-.186-.09-.206-.137-.152-.337.04-.147.08-.294.126-.439.054-.167.098-.19.252-.109.262.137.542.216.836.252.188.024.374.004.548-.072.326-.145.378-.526.102-.754a1.39 1.39 0 0 0-.312-.185c-.286-.127-.586-.224-.854-.387-.438-.264-.716-.627-.684-1.164.036-.607.378-.986.93-1.187.228-.085.228-.08.23-.32v-.244c.004-.182.034-.214.214-.218.056-.002.112 0 .166 0 .38 0 .38 0 .382.383.002.272 0 .274.27.314.206.032.402.095.592.18.104.046.146.12.114.231-.046.165-.092.335-.146.498-.05.155-.098.18-.248.105a1.883 1.883 0 0 0-.938-.188.712.712 0 0 0-.25.053c-.284.125-.332.44-.088.634.122.099.262.17.408.23.252.105.504.203.744.338.756.43.96 1.39.424 2.047z'
        />
      </g>
    </g>
  </Svg>
)

PurchasePowerTeaserScreen.propTypes = propTypes

export default PurchasePowerTeaserScreen
